import { singleton } from "./fable_modules/fable-library.3.7.14/AsyncBuilder.js";
import { Http_request, Http_method, Http_overrideResponseType, Http_send } from "./fable_modules/Fable.SimpleHttp.3.1.0/Http.fs.js";
import { HttpMethod, ResponseTypes } from "./fable_modules/Fable.SimpleHttp.3.1.0/Types.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.14/Choice.js";
import { some } from "./fable_modules/fable-library.3.7.14/Option.js";
import { iterate } from "./fable_modules/fable-library.3.7.14/List.js";
import { map, count } from "./fable_modules/fable-library.3.7.14/Set.js";
import { join } from "./fable_modules/fable-library.3.7.14/String.js";
import { comparePrimitives } from "./fable_modules/fable-library.3.7.14/Util.js";

export function loadAsset(assetName) {
    return singleton.Delay(() => singleton.Bind(Http_send(Http_overrideResponseType(new ResponseTypes(2), Http_method(new HttpMethod(0), Http_request(`assets/${assetName}`)))), (_arg1) => {
        let matchValue;
        return singleton.Return((matchValue = _arg1.content, (matchValue.tag === 2) ? (new FSharpResult$2(0, matchValue.fields[0])) : ((console.error(some("Unable to load asset")), new FSharpResult$2(1, "")))));
    }));
}

export function log(message) {
    console.log(some(message));
}

export function diagnoseCompositeAreas(compositeAreas) {
    iterate((ca) => {
        if (count(ca.ConnectedTo) > 1) {
            const diag = join(",", map((i) => (`${i}`), ca.ConnectedTo, {
                Compare: comparePrimitives,
            }));
            log(`Area: ${ca.Area}, Composite: [${diag}]`);
        }
    }, compositeAreas);
}

